import React, { useState, createContext } from 'react';
import DialogTailwind_V2 from '../DialogTailwind_V2';

export const MessageContext = createContext(null)
let refCallback;

function AlertContextProvider({
    children
}) {

    const [message, setMessage] = useState('') //init and clear

    const AlertMessage = ({ title, onDismiss }) => {
        setMessage(title) //title type string
        refCallback = onDismiss
    }

    return (
        <MessageContext.Provider value={{
            AlertMessage
        }}>
            {message &&
                <DialogTailwind_V2 message={message} resetState={setMessage} onDismiss={() => {
                    if (refCallback) {
                        refCallback()
                    }
                    // console.log(refCallback)
                }} />}
            {children}
        </MessageContext.Provider>
    );
}

export default AlertContextProvider;